
import Component, { mixins } from "vue-class-component"
import { LoadState, Terminart } from "mangdto"
import BestaetigenSofort from "./BestaetigenSofort.vue"
import BestaetigenAbholung2 from "./BestaetigenAbholung2.vue"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import BestaetigenLogic from "@/logic/bestellung_neu/bestaetigen_logic"

@Component({
  components: {
    BestaetigenSofort,
    BestaetigenAbholung2,
    ArtikelRow,
    FilialeHeader,
    NichtGueltig,
  },
})
export default class Bestaetigen extends mixins(Calculator) {
  $refs!: {
    form: HTMLFormElement
  }

  logic: BestaetigenLogic = null

  Terminart = Terminart

  agbRules: any[] = [
    (v: boolean) => {
      if (!v) return "Bitte die AGB akzeptieren"
    },
  ]

  agbAnzeigen() {
    this.logic.agbAnzeigen()
  }

  get bestaetigenLoading() {
    return this.logic.bestaetigenLoadState == LoadState.Loading
  }

  mounted() {
    this.logic = new BestaetigenLogic()
    this.logic.init()
  }

  bestellungBestaetigen() {
    var valid = this.$refs.form.validate()
    if (!valid) return

    this.logic.bestellungBestaetigen()
  }
}
